<template>
  <Alert
    v-if="showAlert"
    dismissible
    class="my-4"
    :data-testid="dataTestid"
    :vuetifyProps="{
      color: 'green',
      dismissible: true,
      icon: 'mdi-cash-multiple',
    }"
    :text="alertText"
  >
    <template #append>
      <PredictedFinancialImpactInfoTooltip
        data-testid="predictedFinancialImpactAlert-infoIcon"
        iconClass="ms-3"
        iconColor="green"
        :text="$t('rev.financial_potential_impact.tooltip')"
      />
    </template>
  </Alert>
</template>

<script>
import _ from 'lodash'

import Alert from '@/components/Alert.vue'
import PredictedFinancialImpactInfoTooltip from '@/components/PredictedFinancialImpactInfoTooltip.vue'
import revMixin from '@/mixins/revMixin.vue'
import moneyMixin from '@/mixins/moneyMixin.vue'
import constants from '@/constants'

export default {
  name: 'PredictedFinancialImpactAlert',

  components: {
    Alert,
    PredictedFinancialImpactInfoTooltip,
  },

  mixins: [revMixin, moneyMixin],

  props: {
    rev: {
      type: Object,
      required: true,
    },
    dataTestid: {
      type: String,
      default: 'predictedFinancialImpactAlert-alert',
    },
  },

  computed: {
    // Keep in sync with ReviewValidation.shouldShowChip - same threshold
    showAlert() {
      return (
        !this.isFinanciallyValidated(this.rev) &&
        _.isNumber(this.rev?.predictedFinancialImpactInUSD) &&
        this.rev?.predictedFinancialImpactInUSD >=
          constants.rev.minSignificantPredictedFinancialImpact
      )
    },

    alertText() {
      const formattedValue = this.formatMoney(
        this.rev?.predictedFinancialImpactInUSD,
        this.getRevCurrency(this.rev)
      )

      return this.$t('rev.financial_potential_impact.alert_text', {
        value: formattedValue,
      })
    },
  },
}
</script>
